/*
 *
 * Can constants
 *
 */

export const DEFAULT_ACTION = 'app/Can/DEFAULT_ACTION';
